import React from 'react'
import '../POSV_New_Ui/PolicySplitingVerify/PolicySplitingVerify.css'
import { crossBtnIcon } from '../../images/btnIcons';
import { Button } from 'unified-ui-components-library';

function IVCPolicySpliting({ policySplittingMessage }) {
    return (
        <div className='policy-splt-verify-cntnr ivc-policy-splitting'>
            <div className='policy-splt-verify-img'>
                <img src={crossBtnIcon} alt="crossmark" />
            </div>
            <div className='policy-splt-verify-head-txt'>
                <p>
                    Policy verification was unsuccessful
                </p>
            </div>
            <div className='policy-splt-verify-para-txt'>
                <p>
                    {policySplittingMessage}
                </p>
            </div>
            <div className='policy-splt-verify-button'>
                <Button
                    buttonType="secondary"
                    width="264"
                >
                    Close this page
                </Button>
            </div>
        </div>
    )
}

export default IVCPolicySpliting;